
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import { User } from '../../../lib/models/User'
import UIkit from 'uikit'

@Component({
  components: {
    BacButton,
    BacModal,
    BacInput
  }
})
export default class SocialSecurityModal extends Vue {
  @Prop({ default: () => new User() }) user!: User

  async updateEditedUser () {
    await this.user.update()
    UIkit.notification({
      message: 'Teilnehmer geupdated!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}

